import React, {Component} from 'react';
import Action from 'components/organisms/projection-boost-rule/actions';
import {connect} from 'react-redux';

class RemoveRuleItem extends Component {
    onClick(itemId) {
        this.props.dispatch(Action.do('removeItemOfProjectionBoostRule', itemId));
    }

    render() {
        const {itemId} = this.props;

        return (
            <span onClick={(() => this.onClick(itemId)).bind(this)} className="tag-remove"></span>
        );
    }
}

export default connect(() => ({}))(RemoveRuleItem);
